module.exports = "img/3.e620c6.webp";